module.exports = __webpack_public_path__ + "static/assets/74e1794c7821c00890a69825d7526c5e.png";